import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useIsLoggedIn } from '../providers/UserProvider';
import { saveProfileAgeRating, saveProfileName } from '../storage/profiles/actions';
import { UPDATE_PROFILES } from '../storage/profiles/actionTypes';

export const useBootstrap = () => {
  const dispatch = useDispatch();
  const [profilesIsLoading, setSProfilesIsLoading] = useState(true);
  const isAuthenticated = useIsLoggedIn();

  const handleIsAuthenticated = useCallback(async () => {
    try {
      dispatch({ type: UPDATE_PROFILES });
    } catch (error) {
      console.error(error);
    } finally {
      setSProfilesIsLoading(false);
    }
  }, [dispatch]);

  const handleClearProfiles = useCallback(() => {
    dispatch(saveProfileAgeRating({}));
    dispatch(saveProfileName(undefined));
  }, [dispatch]);

  useEffect(() => {
    handleClearProfiles();
    if (isAuthenticated) {
      handleIsAuthenticated();
    }
  }, [isAuthenticated, handleIsAuthenticated, handleClearProfiles]);

  return {
    profilesIsLoading,
    isAuthenticated,
  };
};
